import { render, staticRenderFns } from "./productDownload.vue?vue&type=template&id=0f2c361f&scoped=true&"
import script from "./productDownload.vue?vue&type=script&lang=js&"
export * from "./productDownload.vue?vue&type=script&lang=js&"
import style0 from "./productDownload.vue?vue&type=style&index=0&id=0f2c361f&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.10.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f2c361f",
  null
  
)

export default component.exports